import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tooltip } from 'components/core/Tooltip';
import { WarpedShadow } from 'components/core/WarpedShadow';

import './cardBadge.scss';

export function CardBadge({
	className,
	children,
	color,
	icon,
	parentPadding,
	tooltipMessage,
	warpedShadow,
	clickToCloseTooltip,
	hideTooltipForLarge,
}) {
	return (
		<div className={classnames('card-badge-wrapper', parentPadding)}>
			<WarpedShadow
				enabled={warpedShadow}
				className={classnames('badge-shadow', parentPadding)}
			>
				<div
					className={classnames(
						'ph-card-badge',
						className,
						color,
						parentPadding
					)}
				>
					{!tooltipMessage && (
						<Fragment>
							{children}
							{icon && React.createElement(icon)}
						</Fragment>
					)}
					{!!tooltipMessage && (
						<Tooltip
							className="card-badge-tooltip"
							content={tooltipMessage}
							tooltipIcon={icon && React.createElement(icon)}
							iconRightSide
							tooltipShowing
							onFocus
							clickOnMobile
							plainText
							fillParentContainer="right"
							clickToClose={clickToCloseTooltip}
							hideTooltipForLarge={hideTooltipForLarge}
						>
							{children}
						</Tooltip>
					)}
				</div>
			</WarpedShadow>
		</div>
	);
}

CardBadge.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	color: PropTypes.oneOf(['blue', 'orange', 'green']),
	icon: PropTypes.func,
	parentPadding: PropTypes.oneOf(['small', 'medium', 'large', 'vip-card']),
	tooltipMessage: PropTypes.string,
	warpedShadow: PropTypes.bool,
	clickToCloseTooltip: PropTypes.bool,
	hideTooltipForLarge: PropTypes.bool,
};

CardBadge.defaultProps = {
	warpedShadow: true,
};

export default CardBadge;
